module.exports = __webpack_public_path__ + "img/logo.a383c1eb.svg";